import { LayerViewModel } from "@omnia/shared/layers/layerViewModel"
import { selectMany } from "../../../omnia"
import { NutrientType } from "../../../types"
import { getNutrientTypes } from "../../../utils"
import { PlanVm } from "../plan"
import { INutritionMapViewContext } from "../types"
import { RequirementsMapView } from "./requirements"
import { sortDates } from "@omnia/shared/utils/utils"


export class PlanOpeningRequirementsMapView extends RequirementsMapView {

    static create(ctxt: INutritionMapViewContext) {

        let nutrientTypes = getNutrientTypes();

        let plans = ctxt.planReader.getPlans();

        let views = selectMany(plans.map(plan => {

            let key = `ob:${plan.plan.NutritionPlanId}`;
            let name = `"Opening requirements for plan ${plan.name}`;

            let views = nutrientTypes.map(nutrientType => {

                let view = new PlanOpeningRequirementsMapView(name, key, nutrientType, ctxt, plan);
                view.setup();
                return view;

            });

            return views;

        }));

        return views;

    }

    protected constructor(name: string, key: string, nutrientType: NutrientType, ctxt: INutritionMapViewContext, private planVm: PlanVm) {
        super(name, key, nutrientType, ctxt);
    }

    get planId() {
        return this.planVm.planId;
    }

    protected createLayers(): LayerViewModel[] {

        return this.createOpeningReqsLayers();

    }

    protected createOpeningReqsLayers() {

        let nutrientKey = NutrientType[this._nutrient];
        let ctxt = this.ctxt.datalayerContext;

        let cropping = this.planVm.cropping.filter(c => c.cropping.hasBoundary());

        let layerId = 0;

        return cropping
            .sort((a, b) => sortDates(a.cropping.startDate, b.cropping.startDate))
            .map(c => {

                let requirements = this.ctxt.planReader.getPlanRequirements(c.croppingId, this.planId) || [];
                requirements = requirements.filter(r => !r.Aggregate);
                let nutrientRequirements = this.filterNutrientGroup(requirements);

                if (nutrientRequirements.length) {

                    let datalayer = this.createVirtualLayer(++layerId, c.cropping, nutrientRequirements, nutrientKey);

                    let vm = new LayerViewModel(ctxt, this.ctxt.map, datalayer, c.cropping.fieldVm);

                    return vm;

                }


            }).filter(l => !!l);

    }

}
